var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 142,
    viewBox: "0 0 220 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.784 45.3632C102.784 45.3632 123.427 -3.89182 163.403 0.246947C203.378 4.38572 226.657 40.8508 218.313 80.3267C209.968 119.802 164.284 167.548 97.9571 125.443C31.6302 83.3373 99.2409 57.8821 102.784 45.3632Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.442 124.382C194.958 128.076 190.681 129.78 187.064 128.12L96.0056 87.224C94.6204 86.5753 93.9718 84.9483 94.5435 83.5192C95.1151 82.09 96.7092 81.3645 98.1603 81.8592L192.242 115.191C196.013 116.499 197.926 120.688 196.442 124.382Z",
    fill: "#E38A43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5802 58.3551C99.5802 84.7489 78.1839 106.145 51.7901 106.145C25.3964 106.145 4 84.7489 4 58.3551C4 31.9614 25.3964 10.565 51.7901 10.565C78.1839 10.565 99.5802 31.9614 99.5802 58.3551Z",
    fill: "white",
    stroke: "#E38A43",
    strokeWidth: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2274 69.7329H55.5154C54.4354 59.7249 70.1314 58.5009 70.1314 47.9169C70.1314 38.3409 62.4994 33.5169 52.0594 33.5169C44.3554 33.5169 38.0194 36.9729 33.4834 42.3009L39.3874 47.7729C42.9154 44.0289 46.4434 42.0849 50.9074 42.0849C56.5234 42.0849 59.9794 44.5329 59.9794 48.8529C59.9794 55.8369 44.7154 58.4289 46.2274 69.7329ZM50.9074 88.8849C54.5794 88.8849 57.2434 86.2929 57.2434 82.5489C57.2434 78.7329 54.5794 76.1409 50.9074 76.1409C47.3074 76.1409 44.5714 78.7329 44.5714 82.5489C44.5714 86.2929 47.2354 88.8849 50.9074 88.8849Z",
    fill: "#DFDFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.340074ab9aa95f6f81c34eb2ae16ad94.svg";
export { ForwardRef as ReactComponent };